import { AsYouType } from 'libphonenumber-js';

export function formatPhoneNumber(value, country_code = 'NO') {
    if (!value) {
        return '';
    }
    const formatter = new AsYouType(country_code);
    const text = formatter.input(value);

    return text.replace(/\s/g, '\xa0');
}
